import Topnav from './components/Nav/TopBar';
import Sidebar from './components/Nav/SideBar';

import { useStateContext } from './components/Context/ContextProvider';
import AuthToken from './components/Context/AuthToken';
import ProtectedRoute from './components/Context/ProtectedRoute'
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import Home from './pages/Home';
import Login from './pages/Login';
import ListUsers from './pages/Admins/ListAdmins'
import AddUsers from './pages/Admins/AddAdmin'
import UpdateUser from './pages/Admins/UpdateAdmin'
import Profile from './pages/Admins/Profile'
import Reports from './pages/Reports/Reports'

const App = () => {
  const { activeMenu } = useStateContext();

  const { accessToken, setAccessToken } = AuthToken();
  if (!accessToken) {
    return <Login setAccessToken={setAccessToken} />;
  }

  return (
    <main>
      <div className='flex relative'>
        {activeMenu ? (
          <div className='w-60 fixed'>
            <Sidebar />
          </div>
        ) : (
          <div>
            <Sidebar />
          </div>
        )}
        <div className={activeMenu ? 'min-h-screen md:ml-60 w-full' : 'w-full min-h-screen flex-2'}>
          <div>
            <Topnav />
          </div>
          <div>
            <Toaster position='top-center' richColors />
            <Routes>
              {/* dashboard  */}
              <Route path='/' element={<Home />} />
              <Route path='/login' element={<Login setAccessToken={setAccessToken} />} />
              <Route path='/admins' element={<ProtectedRoute><ListUsers /></ProtectedRoute>} />
              <Route path='/addadmin' element={<ProtectedRoute><AddUsers /></ProtectedRoute>} />
              <Route path='/updateadmin/:id' element={<ProtectedRoute><UpdateUser /></ProtectedRoute>} />
              <Route path='/my-profile' element={<Profile />} />
              <Route path='/reports' element={<Reports />} />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
};

export default App;
